import { VStack as NbVStack } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const VStack = NbVStack;

export default addWithConfig(VStack);
